<script>
export default {
  name: 'MaTextWithUnderStrike',
  props: {
    dark: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    strikeType() {
      return this.dark ? 'dark' : 'light'
    },
  },
}
</script>

<template>
  <div class="flex items-center my-6 ma-text-with-under-strike">
    <span class="ma-sep" :class="[`ma-sep--${strikeType}`]" />
    <div class="ma-text-content mx-3">
      <slot />
    </div>
    <span class="ma-sep" :class="[`ma-sep--${strikeType}`]" />
  </div>
</template>

<style lang="scss" scoped>
    .ma-text-content {
  font-size: 1.1rem;
}

.ma-sep {
  display: inline-block;
  height: 1px;
  flex: 1 1 0;
}

.ma-sep--light {
  @apply bg-white;
}

.ma-sep--dark {
  @apply bg-light;
}
</style>
